import React, { useEffect, useState } from 'react'
import { Wrapper } from './Retencion.styles'
import Main from 'src/components/common/Main/Main'
import { GridContainer, GridItem } from 'src/components/common/grids'
import Tabs from '../common/TabSwich/Tabs'
import { configFile, PANEL_COMERCIALES_TAB_INDEX, TRANSACTIONS_TAB_INDEX } from './Retention.constants'
import { RetentionSearchProvider, RetentionSearchBar } from './search'
import { useAppDispatch, useAppSelector } from 'src/hooks/redux'
import { fetchRetentionPermissions } from 'src/redux/permissions/thunks'

const Retention = () => {
    const [activeTab, setActiveTab] = useState(1);
    // Panel Comerciales y Transacciones buscan por su cuenta. En Transacciones
    // un submit de esta barra dispararía suggested_calculator solo para validar
    // el correo; el filtro del listado pega directo a commercial_panel/transactions.
    const showSearchBar =
        activeTab !== PANEL_COMERCIALES_TAB_INDEX &&
        activeTab !== TRANSACTIONS_TAB_INDEX;

    const dispatch = useAppDispatch();
    const { flags, status } = useAppSelector((state) => state.permissions ?? { flags: null, status: 'idle' });

    useEffect(() => {
        dispatch(fetchRetentionPermissions());
    }, [dispatch]);

    const permittedConfigFile = configFile.filter((tab) => {
        if (tab.hidden) return false;
        if (!tab.permissionKey) return true;
        if (status !== 'success') return false;
        return Boolean(flags?.[tab.permissionKey]);
    });

    return (
        <RetentionSearchProvider>
            <Main>
                <Wrapper>
                    <GridContainer className='container'>
                        <GridItem lg={12}>
                            {showSearchBar && <RetentionSearchBar />}
                            <Tabs
                                configFile={permittedConfigFile}
                                activeTab={0}
                                className='retention-tabs'
                                setActiveTab={setActiveTab}
                            />
                        </GridItem>
                    </GridContainer>
                </Wrapper>
            </Main>
        </RetentionSearchProvider>
    )
}

export default Retention
